import _defaultsDeep from 'lodash/defaultsDeep';
import { getWarnings } from '@homeservices/api-kit/search/warnings';
import { persist, load, clear } from '@/utils/state-sync';

export const WARNINGS_STORAGE_NAME = 'WarningsData';

function initialState () {
  return {
    all: {},
    read: {},
  };
}

export const WarningsPlugins = [
  persist({
    name: WARNINGS_STORAGE_NAME,
    keys: [
      'warnings.read',
    ],
  }),
];

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async fetchWarnings ({ commit }, service_provider_id) {
      if (service_provider_id) {
        const { data: { results } } = await getWarnings(
          service_provider_id
        );
        commit('updateWarnings', { warnings: results });
      }
    },
  },
  mutations: {
    updateWarnings (state, { warnings = [] }) {
      state.all = warnings.reduce((acc, next) => ({
        ...acc,
        [next.code]: next,
      }), {});

      // Prune read warnings with new set of warnings from API
      state.read = warnings.reduce((acc, next) => {
        const readWarning = state.read[next.code];
        if (!readWarning) { return acc; }

        return {
          ...acc,
          [next.code]: readWarning,
        };
      }, {});
    },
    markAsRead (state, { warning }) {
      state.read = {
        ...state.read,
        [warning.code]: {
          code: warning.code,
          timestamp: new Date(),
        },
      };
    },
    load (state) {
      const { warnings } = load({ name: WARNINGS_STORAGE_NAME });
      const updatedState = _defaultsDeep(warnings || {}, state);
      Object.assign(state, updatedState);
    },
    clear (state) {
      Object.assign(state, initialState());
      clear({ name: WARNINGS_STORAGE_NAME });
    },
  },
};
